import { render, staticRenderFns } from "./stockunits.vue?vue&type=template&id=92762360&scoped=true&"
import script from "./stockunits.vue?vue&type=script&lang=js&"
export * from "./stockunits.vue?vue&type=script&lang=js&"
import style0 from "./stockunits.vue?vue&type=style&index=0&id=92762360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92762360",
  null
  
)

export default component.exports